import { notification, Upload } from "antd";

import type { RcFile } from "antd/es/upload";
import type { TFunction } from "i18next";

const MAX_FILE_SIZE_MB = 20;

export const createBeforeUpload = (t: TFunction) => {
  return (file: RcFile) => {
    const isLtMax = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;

    if (!isLtMax) {
      const msg = t("support.fileTooLarge", {
        fileName: file.name,
        size: MAX_FILE_SIZE_MB,
      });
      notification.error({ message: msg });
      return Upload.LIST_IGNORE;
    }

    return false;
  };
};
